function fnFullWidthVideo(i, oSection) {
    document.addEventListener("DOMContentLoaded", function() {
        const playBtn = document.querySelector(".video-play-btn");
        const previewImg = document.querySelector(".video-preview");
        const videoWrapper = document.querySelector(".video-wrapper");

        if (!playBtn || !previewImg || !videoWrapper) return;

        let currentIframe = null;
        let closeBtn = null;
        let wrapperClickHandler = null;

        function removeWrapperClick() {
            if (wrapperClickHandler) {
                videoWrapper.removeEventListener('click', wrapperClickHandler);
                wrapperClickHandler = null;
            }
        }

        function cleanupMobileClose() {
            if (closeBtn) {
                closeBtn.remove();
                closeBtn = null;
            }
        }

        function showPreview() {
            // Remove iframe (this stops playback)
            if (currentIframe) {
                currentIframe.remove();
                currentIframe = null;
            }

            // Remove mobile close btn if present
            cleanupMobileClose();

            // Make sure any wrapper click listener is removed
            removeWrapperClick();

            // revert UI
            videoWrapper.classList.add("hidden");
            playBtn.style.display = "flex";
            previewImg.style.display = "block";
        }

        function playVideo() {
            // hide preview ui
            playBtn.style.display = "none";
            previewImg.style.display = "none";
            videoWrapper.classList.remove("hidden");

            // remove any previous iframe/close button
            showPreview(); // safe cleanup then continue — but won't re-hide preview because we update below
            // (we called showPreview to ensure a clean slate, but now we need to re-hide the preview again)
            playBtn.style.display = "none";
            previewImg.style.display = "none";
            videoWrapper.classList.remove("hidden");

            const videoUrl = videoWrapper.getAttribute("data-video-url");
            if (!videoUrl) return;

            // match the media query (mobile if width <= 767.98px)
            const isMobile = window.matchMedia('(max-width: 767.98px)').matches;

            // mobile: muted autoplay + controls visible
            // desktop: autoplay with sound (user clicked), hide controls
            const params = isMobile
                ? "?autoplay=1&muted=1&loop=1&autopause=0&controls=1&title=0&byline=0&portrait=0"
                : "?autoplay=1&muted=0&loop=1&autopause=0&controls=0&title=0&byline=0&portrait=0";


            const iframe = document.createElement("iframe");
            iframe.setAttribute("src", videoUrl + params);
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.border = "0";

            // Desktop: allow clicks on parent wrapper to catch click-to-stop.
            // We let clicks pass through iframe by disabling pointer events on the iframe.
            if (!isMobile) {
                iframe.style.pointerEvents = "none";
                // add wrapper click handler to stop playback
                wrapperClickHandler = function(e) {
                    // ignore clicks that originated from the play button (just in case)
                    showPreview();
                };
                videoWrapper.addEventListener("click", wrapperClickHandler);
            } else {
                // Mobile: iframe must receive pointer events so user can interact with controls / unmute.
                iframe.style.pointerEvents = "auto";

                // add explicit Close button (so user can close without losing the ability to interact with controls)
                cleanupMobileClose();
                closeBtn = document.createElement("button");
                closeBtn.className = "video-close-btn";
                closeBtn.setAttribute("aria-label", "Close video");
                closeBtn.innerHTML = "✕"; // simple X - replace with SVG if you prefer
                // prevent the close button click from bubbling into the iframe/wrapper
                closeBtn.addEventListener("click", function(ev) {
                    ev.stopPropagation();
                    showPreview();
                });
                // append close button before iframe so z-index ordering/CSS can place it on top
                videoWrapper.appendChild(closeBtn);
            }

            videoWrapper.appendChild(iframe);
            currentIframe = iframe;
        }

        playBtn?.addEventListener("click", playVideo);
    });
}
